<script>
    import FormGroup from '~/components/form/components/form_group';
    import ImageCrop from '~/components/image_crop/components/image_crop';

    export default {
        name: "image-crop-wrap",

        components: {
            FormGroup,
            ImageCrop
        },

        data() {
            return {
                label: '',
                uploadError: {
                    'valid': true,
                    'validationState': ''
                },
                modalVisible: false,
                cropped: null
            }
        },

        props: {
            inputName: {
                type: String,
                required: true
            },

            labelName: {
                type: String,
                default: 'Profile Photo: Recommended file size for images is 50kb (max: 1mb)'
            },

            description: {
                type: String,
                default: 'Allowed types are jpg, png, gif (max 1MB)'
            },

            defaultImage: {
                type: String
            },

            allowCrop: {
                type: Boolean,
                default: true
            },

            cropDialogTitle: {
                type: String,
                default: 'Image Cropper'
            },

            useCroppie: {
                type: Boolean,
                default: true
            }
        },

        computed: {
            croppedOrDefault() {
                if(this.defaultImage){
                    return this.cropped = this.defaultImage;
                } else {
                    return this.cropped;
                }
            }
        },

        methods: {
            checkFileSize(file) {
                const below1mb = file.size / 1024 / 1024 <= 1;
                if (!below1mb) {
                    this.uploadError.valid = false;
                    this.uploadError.validationState = 'error';
                }else{
                    this.uploadError.valid = true;
                    this.uploadError.validationState = '';
                    this.modalVisible = true;
                }
            },

            handleImageSave(val) {
                this.$emit('image-saved', val);
            },

            openModal() {
                this.modalVisible = true;
            }
        }
    };
</script>

<template>
    <div>
        <div class="image-crop">
            <form-group
                :label="labelName"
                :description="description"
                :hasError="!uploadError.valid"
                :validation-state="uploadError.validationState"
            >
                <img v-if="croppedOrDefault" :src="cropped" class="cropped-image" @click="openModal">
                <input type="hidden" :name="inputName" class="form-control" :value="cropped"/>
                <image-crop
                    v-model="cropped"
                    :allow-crop="allowCrop"
                    :use-croppie="useCroppie"
                    :crop-dialog-title="cropDialogTitle"
                    :cropModalVisible.sync="modalVisible"
                    :close-on-click-modal="false"
                    :default-image="cropped"
                    :show-close="false"
                    @change="checkFileSize"
                    @input="handleImageSave"
                >
                </image-crop>
            </form-group>
        </div>
    </div>
</template>